import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import { BlogPage } from './components/BlogPage';
import { PrivacyPolicyPage } from './components/pages/PrivacyPolicyPage';
import { TermsOfUsePage } from './components/pages/TermsOfUsePage';
import { LanguageSync } from './components/LanguageSync';
import { DUBBING_LANDING_PATH, getBasePathFromUrlPath, isDubbingPairPath } from './utils/localizedRoutes';

function LocalizedHtmlRouteResolver() {
  const location = useLocation();
  const basePath = getBasePathFromUrlPath(location.pathname);

  if (basePath === '/' || basePath === DUBBING_LANDING_PATH || (basePath && isDubbingPairPath(basePath))) {
    return <HomePage />;
  }
  if (basePath === '/blog') {
    return <BlogPage />;
  }
  if (basePath === '/privacy') {
    return <PrivacyPolicyPage />;
  }
  if (basePath === '/terms') {
    return <TermsOfUsePage />;
  }

  return <Navigate to="/" replace />;
}

function ScrollToTopOnRouteChange() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageSync />
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ai-video-voice-over-dubbing" element={<HomePage />} />
        <Route path="/es/:spanishSeoSlug" element={<LocalizedHtmlRouteResolver />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:articleSlug" element={<BlogPage />} />
        <Route path="/:language/blog/:articleSlug" element={<BlogPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfUsePage />} />
        <Route path="/:localizedHtml" element={<LocalizedHtmlRouteResolver />} />
      </Routes>
    </BrowserRouter>
  );
}
